module.exports = __webpack_public_path__ + "static/media/plywood_diff_1k.2d199684.jpg";